import RestorationInputExtract from 'pages/RestorationInputExtract';

export const restorationInputExtractRoutes = {
    path: '/restoration-input-extract',
    // No PageWrapper since title is set conditionally inside the component
    element: <RestorationInputExtract />,
};
